import { AnyAction, ThunkAction } from '@reduxjs/toolkit';
import { AppState } from 'src/redux/types';
import { getLimitedMode } from 'src/utils/auth/getLimitedMode';
import { annotationActions } from '../actions';
import { selectAnnotationIsQueueProcessing, selectLocalAnnotationCommandGroups } from '../selectors';
import { syncAnnotationCommand } from './sync-annotation-command';

export const processAnnotationQueue =
  (): ThunkAction<Promise<void>, AppState, undefined, AnyAction> => async (dispatch, getState) => {
    const isLocked = selectAnnotationIsQueueProcessing(getState());
    if (isLocked) return;
    const limitedMode = await getLimitedMode();
    if (limitedMode !== undefined) return;

    try {
      dispatch(annotationActions.annotationQueueProcessStart());
      const groups = selectLocalAnnotationCommandGroups(getState());

      for (const group of Object.values(groups)) {
        if (group[0]?.type === 'create' && !group[0]?.parentId) continue; // If the annotation needs to be created but the parent isn't set, skip the entire group.

        try {
          for (const command of group) {
            await dispatch(syncAnnotationCommand(command.commandId));
          }
        } catch (e) {
          console.error('An unhandled error occurred while processing an annotation group', group[0]?.annotationId, e);
        }
      }
    } catch (e) {
      console.error('An unhandled error occurred while processing the annotations queue', e);
    } finally {
      dispatch(annotationActions.annotationQueueProcessComplete());
    }
  };
